import { useResidentContext } from "app/features/residents/provider/ResidentProvider";
import { useGetMedicationReportQuery } from "app/services/api/medicationsApi";
import { RootState } from "app/services/store";
import { selectResidentMedicationLogsById } from "app/store/slices/medications";
import { selectIsOnline } from "app/store/slices/network";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import usePagination from "ui/molecules/pagination/usePagination";

export function useMedicationLogsWithOffline(filters?: {
  medicationId?: number;
  date_from?: string;
  date_to?: string;
}) {
  const { residentId } = useResidentContext();
  const { handlePageChange, currentPage } = usePagination();
  const isOnline = useSelector(selectIsOnline);

  const offlineData = useSelector((state: RootState) =>
    selectResidentMedicationLogsById(state, residentId, filters?.medicationId),
  );
  const {
    data: onlineData,
    isFetching,
    isError,
  } = useGetMedicationReportQuery(
    {
      filter: {
        resident_id: residentId,
        medication_id: filters?.medicationId,
        date_from: filters?.date_from,
        date_to: filters?.date_to,
      },
      page: currentPage,
    },
    { skip: !residentId },
  );

  const data = useMemo(() => {
    if (isFetching || isOnline) return onlineData?.data;
    if (isError && offlineData) return offlineData;
    return onlineData?.data;
  }, [onlineData, offlineData, isOnline, isFetching, isError]);

  return { data, meta: onlineData?.meta, isFetching, handlePageChange };
}
